import React, { useEffect, useState } from "react";
import { uint8ArraysEqual } from "../../utils/CryptoHelpers";
import { getImage } from "../../utils/ImageManager";

export default function ImageMessage({ message, localKeys }) {
  const [imageUrl, setImageUrl] = useState(null);
  const isMe = uint8ArraysEqual(message.senderViewPublicKey, localKeys.viewPublicKey);
  const time_human = message.time_human;

  useEffect(() => {
    (async () => {
      const raw = message.message?.bytes;
      if (!raw || !raw.length) return;

      try {
        const url = await getImage(new Uint8Array(raw));
        setImageUrl(url);
      } catch (err) {
        console.error("Failed to load image:", err);
      }
    })();
  }, [message]);

  return (
    <div
      style={{
        ...styles.container,
        alignSelf: isMe ? "flex-end" : "flex-start",
      }}
    >
      <div
        style={{
          ...styles.bubble,
          backgroundColor: isMe ? "#4e8cff" : "#333",
          borderTopRightRadius: isMe ? 0 : 12,
          borderTopLeftRadius: isMe ? 12 : 0,
        }}
      >
        {imageUrl ? (
          <img src={imageUrl} alt="Sent" style={styles.image} />
        ) : (
          <span style={styles.placeholder}>[Image unavailable]</span>
        )}
      </div>
      <div style={styles.timestamp}>{time_human}</div>
    </div>
  );
}

const styles = {
  container: {
    display: "flex",
    flexDirection: "column",
    marginBottom: "0.5rem",
    maxWidth: "70%",
  },
  bubble: {
    padding: "0.4rem",
    borderRadius: 12,
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    overflow: "hidden",
    maxWidth: "100%",
  },
  image: {
    maxWidth: "100%",
    maxHeight: "200px",
    borderRadius: 8,
    objectFit: "cover",
  },
  placeholder: {
    color: "#fff",
    fontSize: "0.9rem",
  },
  timestamp: {
    fontSize: "0.75rem",
    color: "#aaa",
    marginTop: "0.25rem",
    alignSelf: "flex-end",
  },
};